import { useEffect, useState } from "react";
import { debounceGlobalSearch, getTimeStamp } from "../../common/commonFunctions";
import RecallActivityGrid from "./Grid";
import SearchIcon from "@mui/icons-material/Search";
import { Recall } from "../../common/types/recall";
import withUser from "../../redux/HOC/withUser";
import { getRecallActivityByLenderRefId } from "../../utils/API";
import { useNavigate } from "react-router";


interface RecallActivityProps {
    lender_ref_id: any;
  }
  
  const RecallActivity = ({
    lender_ref_id
  }: RecallActivityProps) => {
    const heightAG_1 = 30;
    const [globalSearch, setGlobalSearch] = useState<string>("");
    const [recalls, setRecalls] = useState<Recall[]>([]);
    const [isActivityProcessing, setIsActivityProcessing] = useState<boolean>(false);
    const navigate = useNavigate();
    
    const onSearch = (event: any) => {
        debounceGlobalSearch(event.target.value, setGlobalSearch);
    };

    useEffect(()=>{
        getRecallActivity(lender_ref_id)
    },[])

    const getRecallActivity = async (refId: any) => {
        setIsActivityProcessing(true);
        let activityRes: any = "";
        let request = {
            "lenderId": refId
        };
        try {
            activityRes = await getRecallActivityByLenderRefId(request);
          if (activityRes?.status === 200) {
            const activityResult = await activityRes.json();
    
            if (activityResult?.length > 0) {
              let rows = activityResult.map((r: any) => ({
                ...r,
                recall_qty: r.recall_qty ? parseInt(r.recall_qty) : 0,
                return_qty: r.return_qty ? parseInt(r.return_qty) : 0,
                createdDate: getTimeStamp(r.create_date),
                updatedDate: getTimeStamp(r.update_date),
              }));
              setRecalls([...rows]);
            }
          } else if (activityRes?.status === 401) {
            navigate("/signin");
          } else {
            setRecalls([])
          }
        } catch (err) {
         setRecalls([])
        } finally {
          setTimeout(() => {
            setIsActivityProcessing(false);
          }, 200);
        }
    };

    return (
        <>
          <div className="d-flex">
            <div className="me-auto mt-1 global-search">
              <input
                type="search"
                placeholder="Global search..."
                id="filter-text-box-sec"
                onInput={onSearch}
              />
              <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
            </div>
          </div>
          
          <RecallActivityGrid
            rowData={recalls}
            height={heightAG_1}
            globalSearch={globalSearch}
            title="Recall Activity"
          />
        </>
    );
  }

  export default withUser(RecallActivity);